import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiBreadcrumbsModule } from '@taiga-ui/kit';
import { TuiLinkModule } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'rdw-cgs',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    TuiBreadcrumbsModule,
    TuiLinkModule,
    RouterLink,
  ],
  templateUrl: './cgs.component.html',
  styleUrls: ['./cgs.component.scss'],
})
export class CgsComponent {
  breadcrumbItems = [
    {
      caption: `breadcrumb.home`,
      routerLink: `/`,
    },
    {
      caption: `breadcrumb.cgs`,
      routerLink: `/cgs`,
      routerLinkActiveOptions: { exact: true },
    },
  ];

  readonly prefixTranslation = 'cgs.';
}
